// extracted by mini-css-extract-plugin
module.exports = {"loader-container":"totalCount_loader-container__3tAyU","loader-count-loader":"totalCount_loader-count-loader__mG4mK"};